export const ADD_POPOVER_CONFIRMED = 'ADD_POPOVER_CONFIRMED';

export const confirmAddPopoverRead = (confirmRead) => ({
	type: ADD_POPOVER_CONFIRMED,
	confirmRead,
});
